/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

var getTransitionParams = function getTransitionParams(_ref) {
  var classPrefix = _ref.classPrefix,
    expandAnimation = _ref.expandAnimation,
    fadeAnimation = _ref.fadeAnimation;
  if (!fadeAnimation) return {};
  var popupAnimationClassPrefix = expandAnimation ? "".concat(classPrefix, "-popup--animation-expand") : "".concat(classPrefix, "-popup--animation");
  return {
    classNames: {
      appear: "".concat(popupAnimationClassPrefix, "-enter ").concat(popupAnimationClassPrefix, "-enter-active"),
      appearActive: "".concat(popupAnimationClassPrefix, "-enter-active"),
      appearDone: "".concat(popupAnimationClassPrefix, "-enter-active ").concat(popupAnimationClassPrefix, "-enter-to"),
      enter: "".concat(popupAnimationClassPrefix, "-enter ").concat(popupAnimationClassPrefix, "-enter-active"),
      enterActive: "".concat(popupAnimationClassPrefix, "-enter-active"),
      enterDone: "".concat(popupAnimationClassPrefix, "-enter-active ").concat(popupAnimationClassPrefix, "-enter-to"),
      exit: "".concat(popupAnimationClassPrefix, "-leave ").concat(popupAnimationClassPrefix, "-leave-active"),
      exitActive: "".concat(popupAnimationClassPrefix, "-leave-active"),
      exitDone: "".concat(popupAnimationClassPrefix, "-leave-active ").concat(popupAnimationClassPrefix, "-leave-to")
    }
  };
};

export { getTransitionParams };
//# sourceMappingURL=transition.js.map
